/**
 * Re-exports — the TanStack Query client lives here so consumers can
 * `import { queryClient } from '@/lib/api'` everywhere.
 */
import { QueryClient } from '@tanstack/react-query';

export { agentApi, agentKeys } from './agent';
export { authApi } from './auth';
export { ApiError, apiFetch, apiJson } from './client';
export { constitutionApi, constitutionKeys } from './constitution';
export { fsApi, fsKeys } from './fs';
export {
  invitationKeys,
  invitationsApi,
  workspaceMemberKeys,
  workspaceMembersApi,
} from './invitations';
export { kanbanApi, kanbanKeys } from './kanban';
export { learningApi, learningKeys } from './learning';
export { projectKeys, projectsApi } from './projects';
export {
  type PushSubscriptionRow,
  pushApi,
  pushKeys,
  type VapidKeyInfo,
} from './push';
export {
  type ActiveSessionsResponse,
  type SessionEstimate,
  type SessionLoad,
  type SystemLoad,
  systemApi,
  systemKeys,
} from './system';
export {
  type DisconnectResult,
  type RegisterWebhookResult,
  type TelegramStatus,
  type TestConnectionResult,
  telegramApi,
  telegramKeys,
} from './telegram';
export {
  bulkApi,
  dependenciesApi,
  dependenciesKeys,
  viewsApi,
  viewsKeys,
} from './views';
export { workspaceApi, workspaceKeys } from './workspace';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Don't retry on auth errors — user has to re-login.
        if (error instanceof Error && error.name === 'ApiError') {
          const status = (error as { status?: number }).status;
          if (status === 401 || status === 403) return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
